import dayjs from "dayjs";

export const STAGES = [
  { key: "client_discussion", label: "Under Discussion", badge: "bg-slate-200 text-slate-800", col: "bg-slate-100/80", dot: "bg-slate-500" },
  { key: "proposal_preparation", label: "Proposal / Estimate in Preparation", badge: "bg-sky-100 text-sky-800", col: "bg-sky-50", dot: "bg-sky-500" },
  { key: "proposal_sent", label: "Proposal / Estimate Sent", badge: "bg-blue-100 text-blue-800", col: "bg-blue-50", dot: "bg-blue-500" },
  { key: "proposal_accepted", label: "Approved", badge: "bg-indigo-100 text-indigo-800", col: "bg-indigo-50", dot: "bg-indigo-500" },
  { key: "live", label: "Live / In Execution", badge: "bg-emerald-100 text-emerald-800", col: "bg-emerald-50", dot: "bg-emerald-500" },
  { key: "executed", label: "Executed", badge: "bg-teal-100 text-teal-800", col: "bg-teal-50", dot: "bg-teal-600" },
  { key: "on_hold", label: "On Hold", badge: "bg-amber-100 text-amber-800", col: "bg-amber-50", dot: "bg-amber-500" },
  { key: "lost_cancelled", label: "Lost / Cancelled", badge: "bg-rose-100 text-rose-800", col: "bg-rose-50", dot: "bg-rose-500" },
];
export const STAGE_MAP = Object.fromEntries(STAGES.map((s) => [s.key, s]));
export const OPEN_STAGES = ["client_discussion", "proposal_preparation", "proposal_sent", "proposal_accepted", "live", "on_hold"];

export const DOC_CATEGORIES = [
  { key: "rfp", label: "Request for Proposal (RFP)", short: "RFP / Brief" },
  { key: "sow", label: "Scope of Work (SOW)", short: "SOW" },
  { key: "estimate", label: "Estimate / Commercial Proposal", short: "Estimate" },
  { key: "po", label: "PO / Service Agreement", short: "PO / Service Agreement" },
  { key: "invoice", label: "Invoices", short: "Invoice" },
  { key: "payment_evidence", label: "Payment & Remittance Documents", short: "Payment doc" },
  { key: "other", label: "Other", short: "Other" },
];
export const CAT_MAP = Object.fromEntries(DOC_CATEGORIES.map((c) => [c.key, c.label]));
export const CHECKLIST_DOC_KEYS = ["rfp", "sow", "estimate", "po"];
export const AUTH_DOC_TYPES = [
  { key: "purchase_order", label: "Purchase Order", cls: "bg-indigo-100 text-indigo-800" },
  { key: "service_agreement", label: "Signed Service Agreement", cls: "bg-emerald-100 text-emerald-800" },
  { key: "supporting", label: "Supporting Document", cls: "bg-slate-100 text-slate-600" },
];
export const AUTH_TYPE_MAP = Object.fromEntries(AUTH_DOC_TYPES.map((t) => [t.key, t]));
export const DOC_STATUS = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-700" },
  sent: { label: "Sent", cls: "bg-blue-100 text-blue-800" },
  accepted: { label: "Accepted", cls: "bg-emerald-100 text-emerald-800" },
  superseded: { label: "Superseded", cls: "bg-slate-200 text-slate-500" },
};
export const AGREEMENT_TYPES = [
  { key: "msa", label: "Master Services Agreement (MSA)", short: "MSA" },
  { key: "cda_nda", label: "Confidentiality Agreement (CDA)", short: "CDA" },
  { key: "nda", label: "Non-Disclosure Agreement (NDA)", short: "NDA" },
  { key: "service_agreement", label: "Service Agreement (project-specific)", short: "Service Agreement" },
  { key: "other_agreement", label: "Other agreement", short: "Other" },
];
export const AGREEMENT_TYPE_MAP = Object.fromEntries(AGREEMENT_TYPES.map((a) => [a.key, a]));
export const SIGNING_STATUS = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-700" },
  awaiting_signatures: { label: "Awaiting Signatures", cls: "bg-amber-100 text-amber-800" },
  signed: { label: "Signed", cls: "bg-emerald-100 text-emerald-800" },
  superseded: { label: "Superseded", cls: "bg-slate-200 text-slate-500" },
};
export const VALIDITY = {
  not_yet_effective: { label: "Not Yet Effective", cls: "bg-sky-100 text-sky-800" },
  current: { label: "Current", cls: "bg-emerald-100 text-emerald-800" },
  renewal_due: { label: "Renewal Due", cls: "bg-orange-100 text-orange-800 font-semibold" },
  expiring_soon: { label: "Expiring Soon", cls: "bg-amber-100 text-amber-800 font-semibold" },
  expired: { label: "Expired", cls: "bg-rose-100 text-rose-800" },
  dates_incomplete: { label: "Dates Not Recorded", cls: "bg-slate-100 text-slate-600" },
  unknown: { label: "Unknown", cls: "bg-slate-100 text-slate-600" },
};
export const CERT_TYPES = [
  { key: "firc", label: "FIRC" },
  { key: "fira", label: "FIRA" },
  { key: "bank_advice", label: "Bank Remittance Advice" },
  { key: "other", label: "Other" },
];
export const CERT_TYPE_MAP = Object.fromEntries(CERT_TYPES.map((c) => [c.key, c.label]));

export const CHECKLIST_STATUSES = [
  { key: "todo", label: "To Do", cls: "bg-slate-100 text-slate-700" },
  { key: "in_progress", label: "In Progress", cls: "bg-sky-100 text-sky-800" },
  { key: "internal_review", label: "Internal Review", cls: "bg-indigo-100 text-indigo-800" },
  { key: "awaiting_client", label: "Awaiting Client", cls: "bg-amber-100 text-amber-800" },
  { key: "completed", label: "Completed", cls: "bg-emerald-100 text-emerald-800" },
];
export const CL_STATUS_MAP = Object.fromEntries(CHECKLIST_STATUSES.map((s) => [s.key, s]));

export const MILESTONE_TRIGGERS = [
  { key: "acceptance", label: "On proposal acceptance" },
  { key: "kickoff", label: "On project kick-off (Live)" },
  { key: "checklist", label: "When checklist task(s) complete" },
  { key: "manual", label: "Manual confirmation" },
];
export const MILESTONE_STATUS = {
  planned: { label: "Planned", cls: "bg-slate-100 text-slate-700" },
  ready: { label: "Ready to invoice", cls: "bg-amber-100 text-amber-800 font-semibold" },
  partially_invoiced: { label: "Partly invoiced", cls: "bg-sky-100 text-sky-800" },
  invoiced: { label: "Invoiced", cls: "bg-blue-100 text-blue-800" },
  paid: { label: "Paid", cls: "bg-emerald-100 text-emerald-800" },
};
export const MILESTONE_PRESETS = [
  { key: "none", label: "Add milestones later" },
  { key: "50_50", label: "50% advance / 50% on completion" },
  { key: "30_40_30", label: "30% advance / 40% interim / 30% final" },
  { key: "100_final", label: "100% on completion" },
];
export const DOC_REQS = [
  { key: "msa", label: "Master service agreement", category: "msa" },
  { key: "po", label: "PO / Service Agreement", category: "po_sow" },
];
export const DOC_REQ_STATES = [
  { key: "required", label: "Required" },
  { key: "not_required", label: "Not required" },
  { key: "pending", label: "Pending decision" },
];
export const FIN_STATUS = {
  not_invoiced: { label: "Not invoiced", cls: "bg-slate-100 text-slate-600" },
  draft: { label: "Draft invoice", cls: "bg-slate-100 text-slate-700" },
  outstanding: { label: "Payment outstanding", cls: "bg-amber-100 text-amber-800" },
  paid: { label: "Fully paid", cls: "bg-emerald-100 text-emerald-800" },
};

export const INVOICE_STATUS = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-700" },
  unpaid: { label: "Unpaid", cls: "bg-amber-100 text-amber-800" },
  partially_settled: { label: "Partially Settled", cls: "bg-amber-100 text-amber-800" },
  awaiting_certificate: { label: "Awaiting remittance certificate", cls: "bg-amber-100 text-amber-800" },
  settled: { label: "Paid / Settled", cls: "bg-emerald-100 text-emerald-800" },
  cancelled: { label: "Void / Cancelled", cls: "bg-slate-200 text-slate-600 line-through" },
};
export const CREDIT_STATUS = { awaiting: { label: "Awaiting credit", cls: "bg-amber-100 text-amber-800" }, credited: { label: "Credited", cls: "bg-emerald-100 text-emerald-800" } };
export const REMIT_DOC_STATUS = { pending: { label: "Awaiting remittance certificate", cls: "bg-amber-100 text-amber-800" }, received: { label: "Certificate received", cls: "bg-emerald-100 text-emerald-800" }, not_applicable: { label: "Certificate N/A", cls: "bg-slate-100 text-slate-600" } };
export const OLD_INVOICE_STATUS = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-700" },
  sent: { label: "Sent", cls: "bg-blue-100 text-blue-800" },
  partially_paid: { label: "Partially paid", cls: "bg-amber-100 text-amber-800" },
  paid: { label: "Paid", cls: "bg-emerald-100 text-emerald-800" },
  cancelled: { label: "Cancelled", cls: "bg-rose-100 text-rose-800" },
};

export function fmtMoney(amount, currency = "INR", opts = {}) {
  if (amount === null || amount === undefined || amount === "") return "—";
  const locale = currency === "INR" ? "en-IN" : "en-US";
  try {
    return new Intl.NumberFormat(locale, { style: "currency", currency, maximumFractionDigits: opts.decimals ?? 0 }).format(amount);
  } catch {
    return `${currency} ${Number(amount).toLocaleString()}`;
  }
}

export const fmtDate = (d) => (d ? dayjs(d).format("DD MMM YYYY") : "—");
export const fmtDateTime = (d) => (d ? dayjs(d).format("DD MMM YYYY, HH:mm") : "—");
export const isPast = (d) => !!d && dayjs(d).isBefore(dayjs(), "day");
export const fmtBytes = (b) => (b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);
